export default "__VITE_ASSET__BggIzF0V__"